<h1 mat-dialog-title>
  <span>Betaalplan wijzigen</span>
  <button mat-icon-button aria-label="Sluiten" (click)="closeDialog('close')"><mat-icon>close</mat-icon></button>
</h1>
<div mat-dialog-content>
  <p>
    Wil je jouw betaalplan wijzigen, bijvoorbeeld door een hoger of lager gebruik te kiezen, klik dan op 'Wijzigen'.
  </p>
  <p>
    Wil je jouw betaalplan verwijderen, klik dan op 'Verwijderen'. Houd er rekening mee dat wanneer je jouw betaalplan
    verwijdert, deze actie permanent is en automatische betalingen direct komen te vervallen.
  </p>
</div>
<div mat-dialog-actions>
  <button mat-button class="error-color" [class.spinner]="editingPlan()" (click)="closeDialog('delete')">
    <mat-icon>delete</mat-icon>
    Verwijderen
  </button>
  <button mat-flat-button [class.spinner]="editingPlan()" (click)="closeDialog('edit')">
    <mat-icon>edit</mat-icon>
    Wijzigen
  </button>
</div>
